module.exports = __webpack_public_path__ + "static/media/card.174c423a.png";